var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loginLoading,
          expression: "loginLoading",
        },
      ],
      staticClass: "login-container",
    },
    [
      _c(
        "div",
        { staticClass: "logo" },
        [
          _c("logoIcon", {
            attrs: { width: "50", height: "50", fill: "#2f70ff" },
          }),
          _c("span", [_vm._v(_vm._s(_vm.computedSystemName))]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "login-type" },
        [
          _c(
            "el-radio-group",
            {
              on: { change: _vm.changeLoginMethod },
              model: {
                value: _vm.loginMethod,
                callback: function ($$v) {
                  _vm.loginMethod = $$v
                },
                expression: "loginMethod",
              },
            },
            [
              _c(
                "el-radio-button",
                {
                  staticStyle: { "margin-right": "25px" },
                  attrs: { label: "password" },
                },
                [_vm._v("密码登录")]
              ),
              _c("el-radio-button", { attrs: { label: "code" } }, [
                _vm._v("验证码登录"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "loginForm",
          staticClass: "login-form",
          attrs: { model: _vm.loginForm, rules: _vm.rules },
        },
        [
          _vm.loginMethod === "code"
            ? [
                _c(
                  "el-form-item",
                  { attrs: { prop: "phone" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入手机号" },
                      model: {
                        value: _vm.loginForm.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.loginForm, "phone", $$v)
                        },
                        expression: "loginForm.phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm.loginMethod === "code"
                  ? _c(
                      "el-form-item",
                      { attrs: { prop: "code" } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 15 } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入验证码" },
                                  model: {
                                    value: _vm.loginForm.code,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.loginForm, "code", $$v)
                                    },
                                    expression: "loginForm.code",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 9 } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "code-btn",
                                    attrs: { disabled: !_vm.canSendCode },
                                    on: { click: _vm.getVerifyCode },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.codeBtnText) + " ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : [
                _c(
                  "el-form-item",
                  { attrs: { prop: "username" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入手机号" },
                      model: {
                        value: _vm.loginForm.username,
                        callback: function ($$v) {
                          _vm.$set(_vm.loginForm, "username", $$v)
                        },
                        expression: "loginForm.username",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "password" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "password",
                        placeholder: "请输入密码",
                        "show-password": "",
                      },
                      model: {
                        value: _vm.loginForm.password,
                        callback: function ($$v) {
                          _vm.$set(_vm.loginForm, "password", $$v)
                        },
                        expression: "loginForm.password",
                      },
                    }),
                  ],
                  1
                ),
              ],
          _c(
            "el-form-item",
            {
              staticClass: "checkbox",
              staticStyle: { "margin-bottom": "0" },
              attrs: { prop: "agree" },
            },
            [
              _c(
                "el-checkbox",
                {
                  staticClass: "agree-text",
                  model: {
                    value: _vm.loginForm.agree,
                    callback: function ($$v) {
                      _vm.$set(_vm.loginForm, "agree", $$v)
                    },
                    expression: "loginForm.agree",
                  },
                },
                [
                  _c("span", { staticClass: "txt" }, [
                    _vm._v("我已阅读并同意用户协议与隐私政策"),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "login-btn",
              attrs: { type: "primary" },
              on: { click: _vm.handleLogin },
            },
            [_vm._v(" 登录 ")]
          ),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "flex justify-end application-btn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: { click: _vm.handleRegisterApplication },
            },
            [_vm._v("申请试用账号")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }